import api from "./apiClient"

export type RefreshResponse = {
  success: boolean
  message: string
  [key: string]: any
}

export const refreshOffers = async (): Promise<RefreshResponse> => {
  const { data } = await api.post("offers/refresh")
  return data
}

export const importOffersFile = async (file: File) => {
  const fd = new FormData()
  fd.append("file", file)

  const url = "offers/import-offers"
  const { data } = await api.post(url, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  })

  return data
}

export const getOffers = async (): Promise<any> => {
  const { data } = await api.get("offers")
  // Some APIs wrap the payload in a `data` key, normalize both shapes
  return data?.data ? data.data : data
}
